import React from 'react';
import './Style.scss';
import Header from './Components/common-header/Header';
import Hero from './Components/Sections/Hero';
import Sections from './Components/Sections/Sections';
// import RelatedContent from './Components/RelatedContents/RelatedContents';
import Footer from './Components/common-footer/Footer';
import contents from './contents.js';
// import ComingSoon from './Components/ComingSoon/ComingSoon';

function StandardHub({ heroBackgroundType }) {
  const bg = heroBackgroundType || contents.hero.background;
  return (
    <main className="StandardHub" id="top">
      <Header clientName={contents.header} />
      <Hero title={contents.hero.title} copy={contents.hero.copy} background={bg} />
      <Sections sectionContents={contents.sectionContents} />
      {/* <ComingSoon />
      <RelatedContent /> */}
      <Footer />
    </main>
  );
}

export default StandardHub;
